<div *ngIf="isLoading" class="loading-panel">
    <kendo-loader fxLayoutAlign="center center" [type]="'infinite-spinner'" [themeColor]="'primary'"
        [size]="size">
    </kendo-loader>
</div>
